import React, { createContext, useContext, useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from './AuthContext';

const FamilyContext = createContext();

export const useFamily = () => {
    return useContext(FamilyContext);
};

export const FamilyProvider = ({ children }) => {
    const { userData } = useAuth();
    const [familyData, setFamilyData] = useState(null);
    const [isHost, setIsHost] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchFamilyData = async () => {
            if (userData && userData.familyId) {
                setLoading(true);
                const familyDocRef = doc(db, 'families', userData.familyId);
                const familyDocSnap = await getDoc(familyDocRef);

                if (familyDocSnap.exists()) {
                    const data = { id: familyDocSnap.id, ...familyDocSnap.data() };
                    setFamilyData(data);
                    // Check if the current user is a host
                    if (data.hosts && data.hosts.includes(userData.uid)) {
                        setIsHost(true);
                    } else {
                        setIsHost(false);
                    }
                } else {
                    setFamilyData(null);
                    setIsHost(false);
                }
                setLoading(false);
            } else {
                 setFamilyData(null);
                 setIsHost(false);
                 setLoading(false);
            }
        };

        fetchFamilyData();
    }, [userData]);

    const value = {
        familyData,
        isHost,
        loadingFamily: loading,
    };

    return (
        <FamilyContext.Provider value={value}>
            {children}
        </FamilyContext.Provider>
    );
};